import en from '../locales/en.json';
import sr from '../locales/sr.json';
import hr from '../locales/hr.json';
import ro from '../locales/ro.json';
import hu from '../locales/hu.json';
import cs from '../locales/cs.json';
import sk from '../locales/sk.json';
import uk from '../locales/uk.json';

export const translations = {
  en,
  sr,
  hr,
  ro,
  hu,
  cs,
  sk,
  uk
};

/**
 * Translate a dotted key path (e.g. "common.add") for a given language code.
 * Standalone equivalent of LanguageContext's `t`, usable without a Provider
 * (e.g. on public pages that render a salon-chosen language, not the app's own).
 */
export function translate(languageCode, key, defaultValue = key, params = {}) {
  const dict = translations[languageCode] || translations.en;
  const keys = key.split('.');
  let value = dict;

  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      return defaultValue;
    }
  }

  let result = value || defaultValue;

  if (typeof result === 'string') {
    result = result.replace(/{appName}/g, dict.appName || 'Dress Desk');

    Object.keys(params).forEach((param) => {
      const regex = new RegExp(`{${param}}`, 'g');
      const paramValue = params[param] !== undefined && params[param] !== null ? params[param] : '';
      result = result.replace(regex, paramValue);
    });
  }

  return result;
}
